import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from './dummyApi';
import { ApiDto } from './api';
const FXM_API_ENABLED = config.servers.fxm.enabled;
const FXM_API_URL = config.servers.fxm.url;
export type UseYN = 'Y' | 'N';
export interface SettingDto {
  name: string;
  updatedTs: number;
  etc: string | null | undefined; // UI 상 사용처는 없음
  useYn: UseYN; // policy setting에서 사용
  dsdCode?: string;
}
export interface AdminSettingPartialDto {
  useUrgency: UseYN;
}
export interface ApplySettingPartialDto {
  allowApproverSameUser: UseYN;
  // UI에 없는듯?
  /*
  sorting: Array<{
    type: 'SELF' | 'MANAGER' | 'POSITION' | 'ROLE' | 'ADMIN'; // 데이터 유형 정의 필요
    option: string; // 데이터 유형 정의 필요
    order: 'UP' | 'DOWN';
  }>;
  */
  excludeApproverUser: string[];
}
export interface CommonSettingPartialDto {
  locale: string;
}
export interface NotiSettingPartialDto {
  useMail: UseYN;
  useFpns: UseYN;
  useWeb: UseYN;
  longTermPeddingApprovalNotificationDay: number;
}
export interface ProxySettingPartialDto {
  limitDay: number;
  limitPerson: number;
  allowAllDept: UseYN;
}
export interface DecryptSettingPartialDto {
  useSubmission: UseYN;
  totalFileSizeMB: number;
  storagePeriod: number;
  useAllowExtensionYn: UseYN;
  allowExtensions: string[];
  useOrder: UseYN;
  maxTotalFiles: number; // 파일 최대 개수
}
export interface ProvisionalSettingPartialDto {
  totalFileSizeMB: number;
  storagePeriod: number;
  useAttachFile: UseYN;
}
export interface ScreenSettingPartialDto {
  limit: number;
  unit: 'DAY'; // 'DAY' | 'WEEK' | 'MONTH' 중 DAY로 고정함
}
export interface TakeoutSettingPartialDto {
  limit: number;
  unit: 'DAY'; // 'DAY' | 'WEEK' | 'MONTH' 중 DAY로 고정함
}
export interface PrintPeriodSettingPartialDto {
  limit: number;
  unit: 'DAY'; // 'DAY' | 'WEEK' | 'MONTH' 중 DAY로 고정함
}
export interface PrintFileSettingPartialDto {
  useSubmission: UseYN;
  totalFileSizeMB: number;
  storagePeriod: number;
  maxTotalFiles: number;
  useAllowExtensionYn: UseYN;
  allowExtensions: string[];
  dsdCode: string;
}
export interface PrintClientSettingPartialDto {
  limit: number;
  unit: 'DAY'; // 'DAY' | 'WEEK' | 'MONTH' 중 DAY로 고정함
}
export type AdminSettingDto = SettingDto & AdminSettingPartialDto;
export type ApplySettingDto = SettingDto & ApplySettingPartialDto;
export type CommonSettingDto = SettingDto & CommonSettingPartialDto;
export type NotiSettingDto = SettingDto & NotiSettingPartialDto;
export type ProxySettingDto = SettingDto & ProxySettingPartialDto;
export type DecryptSettingDto = SettingDto & DecryptSettingPartialDto;
export type ProvisionalSettingDto = SettingDto & ProvisionalSettingPartialDto;
export type ScreenSettingDto = SettingDto & ScreenSettingPartialDto;
export type TakeoutSettingDto = SettingDto & TakeoutSettingPartialDto;
export type PrintPeriodSettingDto = SettingDto & PrintPeriodSettingPartialDto;
export type PrintFileSettingDto = SettingDto & PrintFileSettingPartialDto;
export type PrintClientSettingDto = SettingDto & PrintClientSettingPartialDto;
export interface CommonSettingApiDto {
  name: string;
  version: string;
  globalSetting: SettingDto;
}
export interface SubSettingApiDto {
  name: string;
  version: string;
  globalSubSetting: SettingDto;
}
export type SettingReqDto = Omit<SettingDto, 'updatedTs'>;
export type AdminSettingReqDto = Omit<AdminSettingDto, 'updatedTs'>;
export type ApplySettingReqDto = Omit<ApplySettingDto, 'updatedTs'>;
export type CommonSettingReqDto = Omit<CommonSettingDto, 'updatedTs'>;
export type NotiSettingReqDto = Omit<NotiSettingDto, 'updatedTs'>;
export type ProxySettingReqDto = Omit<ProxySettingDto, 'updatedTs'>;
export type DecryptSettingReqDto = Omit<DecryptSettingDto, 'updatedTs'>;
export type ProvisionalSettingReqDto = Omit<ProvisionalSettingDto, 'updatedTs'>;
export type ScreenSettingReqDto = Omit<ScreenSettingDto, 'updatedTs'>;
export type TakeoutSettingReqDto = Omit<TakeoutSettingDto, 'updatedTs'>;
export type PrintPeriodSettingReqDto = Omit<PrintPeriodSettingDto, 'updatedTs'>;
export type PrintFileSettingReqDto = Omit<PrintFileSettingDto, 'updatedTs'>;
export type PrintClientSettingReqDto = Omit<PrintClientSettingDto, 'updatedTs'>;
interface SettingApi {
  listCommon(): Promise<CommonSettingApiDto[]>;
  listSub(): Promise<SubSettingApiDto[]>;
  updateCommon(reqDto: SettingReqDto): Promise<CommonSettingApiDto>;
  updateSub(reqDto: SettingReqDto): Promise<SubSettingApiDto>;
  listCommonWithToken(token: string): Promise<CommonSettingApiDto[]>;
  listSubWithToken(token: string): Promise<SubSettingApiDto[]>;
}
class SettingServerApi implements SettingApi {
  async listCommon(): Promise<CommonSettingApiDto[]> {
    let subUrl = 'setting';
    if (import.meta.env.VITE_APP_TYPE === 'user') {
      subUrl = 'user';
    }

    const resp = await axios.get<CommonSettingApiDto[]>(`${FXM_API_URL}/api/${subUrl}/common`);
    return resp.data;
  }
  async listCommonWithToken(token: string): Promise<CommonSettingApiDto[]> {
    let subUrl = 'setting';
    if (import.meta.env.VITE_APP_TYPE === 'user') {
      subUrl = 'user';
    }

    const resp = await axios.get<CommonSettingApiDto[]>(`${FXM_API_URL}/api/${subUrl}/common`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return resp.data;
  }
  async listSub(): Promise<SubSettingApiDto[]> {
    let subUrl = 'setting';
    if (import.meta.env.VITE_APP_TYPE === 'user') {
      subUrl = 'user';
    }
    const resp = await axios.get<SubSettingApiDto[]>(`${FXM_API_URL}/api/${subUrl}/sub`);
    return resp.data;
  }
  async listSubWithToken(token: string): Promise<SubSettingApiDto[]> {
    let subUrl = 'setting';
    if (import.meta.env.VITE_APP_TYPE === 'user') {
      subUrl = 'user';
    }

    const resp = await axios.get<SubSettingApiDto[]>(`${FXM_API_URL}/api/${subUrl}/sub`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return resp.data;
  }
  async updateCommon(reqDto: SettingReqDto): Promise<CommonSettingApiDto> {
    const resp = await axios.post<CommonSettingApiDto>(`${FXM_API_URL}/api/setting/common`, reqDto);
    return resp.data;
  }
  async updateSub(reqDto: SettingReqDto): Promise<SubSettingApiDto> {
    const resp = await axios.post<SubSettingApiDto>(`${FXM_API_URL}/api/setting/sub`, reqDto);
    return resp.data;
  }
}
const settingApi = new SettingServerApi();
export default settingApi;
